import { render, staticRenderFns } from "./AddSampleModal.vue?vue&type=template&id=c8ecd092&scoped=true"
import script from "./AddSampleModal.vue?vue&type=script&lang=js"
export * from "./AddSampleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ecd092",
  null
  
)

export default component.exports